import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Timer from 'src/store/models/Timer';
import Todo from 'src/store/models/Todo';
import Phase from 'src/store/models/Phase';
import moment from 'moment/moment';
export default {
  props: {
    todoId: {
      required: true
    },
    mini: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },
  computed: {
    todo: function todo() {
      return Todo.query().where('todo_id', this.todoId).with(['todo_list.project', 'tags']).first();
    },
    activeTimerSeconds: function activeTimerSeconds() {
      return moment.utc().diff(moment.utc(this.todoTimer.timer_start), 'seconds') + this.todoTimer.seconds;
    },
    todoTimer: function todoTimer() {
      return Timer.query().where('todo_id', this.todoId).where('user_id', this.me.user_id).first();
    }
  },
  methods: {
    editTimer: function editTimer() {
      this.openDialog('RegisterTimeDialog', {
        type: 'timer',
        entity: this.todoTimer
      });
    },
    copyTimer: function copyTimer(event) {
      this.openDialog('RegisterTimeDialog', {
        type: 'timer',
        entity: this.todoTimer,
        copy: true
      });
    },
    saveAsAnEntry: function saveAsAnEntry(event) {
      var _this = this;

      if (this.loading) return;
      this.loading = true;
      this.todoTimer.$saveAsAnEntry(this.todoTimer).then(function () {
        _this.$q.notify({
          type: 'positive',
          message: _this.$t('general.timer_saved')
        });
      }).catch(function () {}).finally(function () {
        _this.loading = false;
      });
    },
    deleteTimer: function deleteTimer(event) {
      var _this2 = this;

      if (this.loading) return;
      this.loading = true;
      this.todoTimer.$delete().then(function () {
        _this2.$q.notify({
          type: 'positive',
          message: _this2.$t('general.deleted_timer')
        });
      }).catch(function () {}).finally(function () {
        _this2.loading = false;
      });
    },
    toggleStatus: function toggleStatus(event) {
      var _this3 = this;

      if (this.loading) return;
      this.loading = true;
      this.todoTimer.$toggleStatus().then(function (timer) {
        _this3.$q.notify({
          message: timer.timer_status === 'running' ? _this3.$t('timer.timer_paused') : _this3.$t('timer.timer_started'),
          type: 'positive'
        });
      }).catch(function () {}).finally(function () {
        _this3.loading = false;
      });
    },
    openRegisterTimeDialog: function openRegisterTimeDialog() {
      var _this4 = this;

      var myPhase = null;

      if (this.todo && this.todo.todo_list) {
        if (this.todo.todo_list.integration_todo_list_id) {
          myPhase = Phase.query().where('is_open', 1).where('project_id', this.todo.todo_list.project_id).where(function (phase) {
            return phase.integration_int1 === _this4.todo.todo_list.integration_todo_list_id;
          }).first();
        }

        if (!myPhase) {
          myPhase = Phase.query().where('is_open', 1).where('project_id', this.todo.todo_list.project_id).where(function (phase) {
            return phase.name === _this4.todo.todo_list.name;
          }).first();
        }
      }

      this.openDialog('RegisterTimeDialog', {
        todoId: this.todoId,
        projectId: this.todo && this.todo.todo_list ? this.todo.todo_list.project_id : null,
        tagIds: this.todo.tags.map(function (tag) {
          return tag.tag_id;
        }),
        phaseId: myPhase ? myPhase.task_id : null
      });
    }
  }
};